import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SsqProperty } from "src/api/sure-api/actions/useGetOneAction";

type ActionMultiPropertyProps = {
    property: SsqProperty;
};
export const ActionMultiProperty = (props: ActionMultiPropertyProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { property } = props;

    return <>{t("action_plan.action.multi_property", "Multi property")}</>;

    // const startTitle = t("action_plan.value_in_year", { year: startProperty.campaign?.label });
    // const targetTitle = `${t("goal")} ${endProperty.campaign?.label}`;

    // const maxIterations = endProperty.content.length;
    // return (
    //     <Stack padding={theme.spacing(3)}>
    //         <Stack
    //             gap={theme.spacing(3)}
    //             padding={theme.spacing(3, 0, 3, 0)}
    //             border={`1px solid ${theme.custom.grey[500]}`}
    //             borderRadius={theme.spacing(1.5)}
    //         >
    //             {endProperty.content.map((propertyGroup, rowIndex) => {
    //                 const propertyGroupsOfStart = startProperty.content[rowIndex] ?? [];
    //                 const borderStyle = rowIndex + 1 === maxIterations ? "none" : `1px solid ${theme.custom.grey[500]}`;
    //                 return (
    //                     <Stack
    //                         key={`${rowIndex}-multivalue`}
    //                         borderBottom={borderStyle}
    //                         gap={theme.spacing(2)}
    //                         paddingBottom={theme.spacing(2)}
    //                     >
    //                         <PropertyHeader startTitle={startTitle} targetTitle={targetTitle} />
    //                         {propertyGroup.map((subproperty) => {
    //                             const subpropertyId = subproperty.property.id;
    //                             const foundStarting = propertyGroupsOfStart.find(
    //                                 (item) => item.property.id === subpropertyId,
    //                             );
    //                             const foundTarget = propertyGroup.find((item) => item.property.id === subpropertyId);
    //                             return [
    //                                 <Stack key={`${rowIndex}-${subpropertyId}-inner`} flexDirection={"row"}>
    //                                     <CenteredStack
    //                                         borderRight={`1px solid ${theme.custom.grey[1400]}`}
    //                                         gap={theme.spacing(0.5)}
    //                                     >
    //                                         <Fragment>
    //                                             <ValueSwitch
    //                                                 comparisonProperty={undefined}
    //                                                 property={foundStarting}
    //                                                 title={foundStarting?.property.title}
    //                                                 variant="readonly"
    //                                             />
    //                                         </Fragment>
    //                                     </CenteredStack>
    //                                     <CenteredStack>
    //                                         <ValueSwitch
    //                                             comparisonProperty={foundStarting}
    //                                             property={foundTarget}
    //                                             title={foundTarget?.property.title}
    //                                             shouldShowSubscore={endProperty.isSubpropertyOverriden}
    //                                         />
    //                                     </CenteredStack>
    //                                 </Stack>,
    //                             ];
    //                         })}
    //                     </Stack>
    //                 );
    //             })}
    //         </Stack>
    //     </Stack>
    // );
};
